import"./Coach.css"

const Coach = () => {
  return (
    <>
    <div className="Coach">
        <span>TEAM OF EXPERT</span>
        <span> COACHES</span>
        <p>Lorem Ipsum is simply dummy text of
             the printing and typesetting industry. 
             the readable content   of a page when 
             looking at its layout.

</p>

<div className="coachpartner">
    <div className="partner">
    <img src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/celebrity-fitness-trainer-harley-pasternak-helped-introduce-news-photo-518418190-1538158845.jpg" alt="trainer" />
    <span>Jhon kartly</span>
    </div>
    <div className="partner">
    <img src="https://i.pinimg.com/564x/24/a7/10/24a710f02dfc2001c7b66a3e9c27fc4d--bodybuilders-tans.jpg" alt="trainer" />
    <span>alber Dayno</span>
    </div>
    <div className="partner">
    <img src="https://hips.hearstapps.com/hmg-prod/images/jahkeen-washington-1606142367.jpg?crop=1.00xw:0.947xh;0,0.0530xh&resize=480:*" alt="trainer" />
    <span>Ghosty Parlo</span>
    </div>
</div>
        
        </div>
        </>
  )
}

export default Coach